document.addEventListener('contextmenu', (e) => {
	// Only block the context menu when the right click happens on an image.
	if (e.target instanceof window.Element && e.target.closest('img')) {
		e.preventDefault();
	}
});
